<template>
    <div class="step-content-lint-text" v-if="value.products.length > 0">
        <div class='step-content-line'>
            <p class='text active'>
                <span class="first-step2"> {{value.products.length}} Products Selected </span>
                <span class="second-title-step2"> Across {{group_length}} Product Groups </span>
            </p>
        </div>
    </div>
    <div class="step-content-lint-text" v-else>
        <div class='step-content-line'>
            <p class='text'>Choose and set details for the products targeted in this promotion</p>
        </div>
    </div>
</template>
<script>
export default {
	name: 'step-2-data',
	computed: {
		value() {
			return this.$store.getters['pmcreate/value']
        },
        group_length() {
            return this.$store.getters['pmcreate/product_group_length']
        }
	},
}
</script>
